import React from 'react';
import { useNavigate } from 'react-router-dom';
import { pageMappr } from '../../utils/helper';
import {
  AddressBook,
  CalendarBlank,
  ClipboardText,
  ListMagnifyingGlass,
  Notebook,
  ReportsIcon,
  RolesIcon,
  ReceiptIcon,
  SteeringWheelIcon,
  CompanyGroupsIcon,
  GiftIcon,
  DocumentsIcon,
} from '../../icons';

const IconList = {
  'Booking Reporting': <CalendarBlank />,
  'Download Logs': <Notebook />,
  'Offers Check': <ListMagnifyingGlass />,
  'Offers Reporting': <ClipboardText />,
  Roles: <RolesIcon />,
  Users: <AddressBook />,
  Invoice: <ReceiptIcon className={'stroke-fadedgrey w-[80px] h-[80px]'} />,
  Reports: <ReportsIcon />,
  'Import Drivers': <SteeringWheelIcon />,
  'Company Groups' : <CompanyGroupsIcon />,
  "Loyalty Program": <GiftIcon className={'w-[80px] h-[80px]'} color={"#a5a5a5"}/>,
  "Documents" : <DocumentsIcon className={'stroke-fadedgrey w-[80px] h-[80px]'} />,
};

const DashboardComponent = ({ pageName, pageAccess }) => {
  const navigate = useNavigate();

  if (!pageAccess.includes(pageName)) {
    return null;
  }

  const pageDetails = pageMappr(pageName);
  const { title, btnText, description } = pageDetails;
  return (
    <div className="flex w-full bg-[#FFFFFF99] rounded-[12px] p-6 flex-col justify-between min-h-[290px] lg:min-h-[314px]">
      <div className="flex flex-col gap-4 pb-2">
        {IconList[pageName]}
        <h3>{title}</h3>
        <p className="text-body">{description}</p>
      </div>
      <div className="flex lg:justify-end">
        <button
          className={
            'bg-primary max-lg:w-full py-3 px-10 text-primary-button text-white rounded-[6px]'
          }
          onClick={() => navigate(pageDetails.navigationUrl)}
        >
          {btnText}
        </button>
      </div>
    </div>
  );
};

export default DashboardComponent;
